import { render, staticRenderFns } from "./actionsColumnWithManageAccessCustomer.vue?vue&type=template&id=227a564c"
import script from "./actionsColumnWithManageAccessCustomer.vue?vue&type=script&lang=js"
export * from "./actionsColumnWithManageAccessCustomer.vue?vue&type=script&lang=js"
import style0 from "./actionsColumnWithManageAccessCustomer.vue?vue&type=style&index=0&id=227a564c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports